import { COMMISSIONS_WITHHOLDING_TAX_PERCENTAGE } from '../../resources/constants';
import { Company } from '../company/Company';
import { Payout } from '../payout/Payout';
import { Settlement } from '../settlement/Settlement';
import { ICommission } from './ICommission';

export class Commission {
  createdOn: Date | null;
  currency: string | null;
  currencyRate: number;
  customerName: string;
  dateOfPayment?: Date;
  grossCommissionAmount: number;
  grossPremiumAmount: number;
  id: string;
  isPaid: boolean;
  insurerId: string;
  netCommissionAmount: number;
  netPremiumAmount: number;
  policyNumber: string;
  policyPaymentRef: string;
  policyType: string;
  protectionType: string;
  rate: number;
  reference: string;
  updatedOn?: Date;
  withholdingTax: number;
  broker?: Company;
  payout?: Payout;
  settlement?: Settlement | Payout;


  constructor(Imodel: ICommission) {
    this.id = Imodel.id;
    this.createdOn = Imodel.createdOn ? new Date(Imodel.createdOn) : new Date();
    this.updatedOn = Imodel.updatedOn ? new Date(Imodel.updatedOn) : undefined;
    this.dateOfPayment = Imodel.dateOfPayment ? new Date(Imodel.dateOfPayment) : undefined;
    this.grossCommissionAmount = Imodel.grossCommissionAmount;
    this.currency = Imodel.currency;
    this.currencyRate = Imodel.currencyRate;
    this.customerName = Imodel.customerName;
    this.rate = Imodel.rate;
    this.isPaid = Imodel.isPaid;
    this.insurerId = Imodel.insurerId;
    this.grossPremiumAmount = Imodel.grossPremiumAmount;
    this.protectionType = Imodel.protectionType;
    this.policyType = Imodel.policyType;
    this.policyNumber = Imodel.policyNumber;
    this.policyPaymentRef = Imodel.policyPaymentRef;
    this.reference = Imodel.reference;
    this.broker = Imodel.broker ? new Company(Imodel.broker) : undefined;
    this.withholdingTax = Imodel.withholdingTax;
    this.netCommissionAmount = Imodel.netCommissionAmount;
    this.netPremiumAmount = Imodel.netPremiumAmount;
    this.payout = Imodel.payout;
    this.settlement = Imodel.payout;
  }
}
